<template>
	<div class="">
		<a href="#/backoffice/signatures">← back</a>
		<h1 class="text-center">Add signature</h1>
		<div class="row">
			<div class="col-md-6 offset-md-3">
				<div class="panel panel-login">
					<div class="panel-body">
						<div class="row">
							<div class="col-lg-12">
								<ValidationObserver ref="form">
									<form id="login-form" role="form" name="signatureForm">
										<h3>Company/Organization details</h3>
										<validation-provider rules="required" v-slot="{errors,classes }">
											<div class="form-group">
												<label>organization name <span class="text-danger">*</span></label>
												<input type="text" name="organization" id="organization" class="form-control"
												       placeholder="organization" v-model="sigObj.organization" :class="classes">
												<div class="invalid-feedback">{{ errors[0] }}</div>
												<span class="form-text">the organization name</span>
											</div>
										</validation-provider>
										<validation-provider rules="required" v-slot="{errors,classes }">
											<div class="form-group">
												<label>domain <span class="text-danger">*</span></label>
												<input type="text" name="domain" id="domain" class="form-control"
												       placeholder="domain.com"
												       v-model="sigObj.domain" :class="classes">
												<div class="invalid-feedback">{{ errors[0] }}</div>
												<span class="form-text">may contain any String value</span>
											</div>
										</validation-provider>
										<validation-provider rules="required" v-slot="{errors,classes }">
											<div class="form-group">
												<label>common name <span class="text-danger">*</span></label>
												<input type="text" name="name" id="name" class="form-control" placeholder="company name"
												       value="" v-model="sigObj.name" :class="classes">
												<div class="invalid-feedback">{{ errors[0] }}</div>
												<span class="form-text">The name of the signer if you will not specify it when sigining a document</span>
											</div>
										</validation-provider>
										<div class="form-group">
											<label>Organization ID</label>
											<input type="text" name="organization_id" id="organization_id" class="form-control"
											       placeholder="i.e.: 1234567" v-model="sigObj.organization_id">
										</div>
										<validation-provider rules="email" v-slot="{errors,classes }">
											<div class="form-group">
												<label>email</label>
												<input type="email" name="email" id="email" class="form-control"
												       placeholder="email@mydomain.com"
												       v-model="sigObj.email" :class="classes">
												<div class="invalid-feedback">{{ errors[0] }}</div>
											</div>
										</validation-provider>


										<div class="form-group">
											<label>country</label>
											<input type="text" name="country" id="country" class="form-control"
											       placeholder="IL" v-model="sigObj.country">
											<span class="form-text">Two letters i.e.: IL\US\FR...</span>
										</div>
										<div class="form-group">
											<label>state</label>
											<input type="text" name="state" id="state" class="form-control"
											       placeholder="Company state or leave empty"
											       v-model="sigObj.state">
										</div>
										<div class="form-group">
											<label>password</label>
											<input type="text" name="password" id="password" class="form-control"
											       placeholder="if you use password here, you must send it for every PDF sign request"
											       v-model="sigObj.password">
											<span class="form-text">voluntary field, if you'll set value here the signature will be locked with password, and only you'll be able to use it</span>
										</div>


										<div class="form-group">
											<div class="row">
												<div class="col-sm-6 col-sm-offset-3">
													<input type="button" class="form-control btn btn-primary"
													       value="create signature" v-on:click="createSig()">
												</div>
											</div>
										</div>
									</form>
								</ValidationObserver>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import ApiService from "../../../libs/ApiService";
	import RouterService from "../../../libs/RouterService";

	export default {
		name: "SignatureForm",
		data() {
			return {
				sigObj: {
					organization: '',
				}
			}
		},
		methods: {
			async createSig() {
				//trigger validation
				if (!await this.$refs.form.validate()) {
					return;
				}
				await ApiService.post('/private/signatures', this.sigObj);
				RouterService.push('/backoffice/signatures');
			}
		}
	}
</script>

<style scoped>

</style>